export default {
  FRONTPAGE_DESKTOP: 13,
  FRONTPAGE_MOBILE: 3,

  CALENDAR_DESKTOP: 3,
  CALENDAR_MOBILE: 3,

  SHOP_DESKTOP: 3,
  SHOP_MOBILE: 3,

  RESULTS_DESKTOP: 6,
  RESULTS_MOBILE: 6,

  PEOPLE_MOBILE: 2,
  HORSES_MOBILE: 2,
  ORGANISATIONS_MOBILE: 2,

  SUPPORT_DESKTOP: 2,
  SUPPORT_MOBILE: 3,

  RANKING_DESKTOP: 3,
  RANKING_MOBILE: 3,

  TAKEOVER_DESKTOP: 1,
  TAKEOVER_MOBILE: 1
};
